




























































import { Component, Watch } from 'vue-property-decorator';
import { AuthModule } from '@/store/Auth/AuthModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { LOCALES } from "@/i18n/locales";
import { defaultLocale } from "@/i18n";
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'ProfileSettings' })
export default class extends SaascadaVue {

    dialog: boolean = false;
    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;
    // Initialise settings based on the previously saved user preferences
    selectedLanguage: string = localStorage.getItem("saascada-preferred-language") ? localStorage.getItem("saascada-preferred-language") : defaultLocale;

    get me() {
        return AuthModule.me;
    }

    get languages() {
        return LOCALES;
    }

    @Watch('selectedLanguage')
    async onSelectedLanguageChanged(selectedLanguage: string) {
        this.$i18n.locale = selectedLanguage;
        localStorage.setItem("saascada-preferred-language", selectedLanguage);
    }

    close() {
        this.dialog = false;
    }

};
